import { InitOptions } from '@domgen/checkout-sdk-types';
import { CheckoutStatus } from './checkout-status.type';

export type CheckoutPayloadValidationError = {
  status: CheckoutStatus;
  error: InitOptions['error']['issues'];
};
